import { LayerProps } from 'shared/map-exports';
import { LabelTooltipBackground } from './icons';
import { FONT_NAMES } from './styles';

export const TOOLTIP_LABEL_LAYOUT_STYLES: LayerProps['layout'] = {
  'text-font': FONT_NAMES.regular,
  'text-size': 12,
  'icon-text-fit': 'both',
  'text-max-width': 1000,
  'icon-image': LabelTooltipBackground.name,
  // Adjusted padding to account for the background image
  'icon-text-fit-padding': [4, 8, 4, 8],
};
